import { gql } from '@apollo/client';

export const UPDATE_METRIC_PERMISSION = gql`
  mutation UpdateMetricPermission(
    $permissionData: UpdateMetricPermissionInput!
  ) {
    updateMetricPermission(permissionData: $permissionData) {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MULTIPLE_METRIC_PERMISSIONS = gql`
  mutation UpdateMultipleMetricPermissions(
    $permissionsData: UpdateMultipleMetricPermissionsInput!
  ) {
    updateMultipleMetricPermissions(permissionsData: $permissionsData) {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MY_METRIC_PERMISSIONS = gql`
  mutation UpdateMyMetricPermissions(
    $permissionsData: UpdateMyMetricPermissionsInput!
  ) {
    updateMyMetricPermissions(permissionsData: $permissionsData) {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
    }
  }
`;
